import React, { useEffect, useState } from "react";
import { FiSearch } from "react-icons/fi";
import LoadingPage from "../Loading/loading";
import { getForms, hideForm } from "../../api/forms";
import { useNavigate } from "react-router-dom";
import { Cookies } from "react-cookie";

const FormComponent = (props) => {
  const navigate = useNavigate();
  const cookie = new Cookies();
  const [isSuper, setIsSuper] = useState(cookie.get("isSuper"));
  const [searchTerm, setSearchTerm] = useState("");
  const [forms, setForms] = useState(null);
  const [formsFinal, setFormsFinal] = useState(null);
  const [hideId, setHideId] = useState("");

  useEffect(() => {
    setForms(null);
    setFormsFinal(null);
    ForGet();
  }, []);

  const ForGet = () => {
    getForms(props.formType).then((result) => {
      setForms(result.data.response);
      setFormsFinal(result.data.response);
    });
  };

  const hide = (id) => {
    hideForm(id).then((result) => {
      ForGet();
      setHideId("");
    });
  };

  const handleSearch = (e) => {
    const value = e.target.value;
    setSearchTerm(value);

    if (value) {
      setFormsFinal(
        forms.filter(
          (form) =>
            form.user_id.name.toLowerCase().includes(value.toLowerCase()) ||
            form.user_id.phone.toLowerCase().includes(value.toLowerCase()),
        ),
      );
    } else {
      setFormsFinal(forms);
    }
  };

  /*forms.filter(form =>
        form.developer.toLowerCase().includes(searchTerm.toLowerCase()) ||
        form.phone.includes(searchTerm)
    )*/

  return (
    <>
      {formsFinal === null ? (
        <LoadingPage />
      ) : (
        <div>
          <div className="search-container">
            <div className="search-input-wrapper">
              <FiSearch className="search-icon" />
              <input
                type="text"
                placeholder="Name or Phone number"
                value={searchTerm}
                onChange={handleSearch}
                className="search-input"
              />
            </div>
          </div>

          <div>Number of Deals is {formsFinal.length}</div>

          <div className="card-cards">
            {formsFinal?.map((form) => (
              <div key={form._id} className={`card-card`}>
                <div className="card-info">
                  <div>
                    <p className="line">
                      <span className="label">Broker name:</span>{" "}
                      {form?.user_id?.name}
                    </p>
                    <p className="line">
                      <span className="label">Broker phone:</span>{" "}
                      {form?.user_id?.phone}
                    </p>
                    <p className="line">
                      <span className="label">Developer:</span>{" "}
                      {form?.developer}
                    </p>
                    <p className="line">
                      <span className="label">Project name:</span>{" "}
                      {form?.project_name}
                    </p>
                    <p className="line">
                      <span className="label">Deal value:</span>{" "}
                      {form?.deal_value}
                    </p>
                    <p className="line">
                      <span className="label">Admin Code:</span>{" "}
                      {form?.admin_code}
                    </p>
                    <p className="line">
                      <span className="label">Create at:</span>{" "}
                      {form?.createdAt.split("T")[0]}
                    </p>
                    {hideId === form._id && (
                      <div
                        style={{
                          border: "1px solid #ddd",
                          borderRadius: "4px",
                          padding: "5px",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <p className="line">
                          Are you sure you want to delete this?{" "}
                        </p>
                        <div className="card-info">
                          <div className="card-actions">
                            <button
                              onClick={() => {
                                setHideId("");
                              }}
                              className="action-btn accept-btn"
                            >
                              No
                            </button>
                          </div>
                          <div className="card-actions">
                            <button
                              onClick={() => {
                                hide(form._id);
                              }}
                              className="action-btn remove-btn"
                            >
                              Yes
                            </button>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
                <div>
                  <button
                    onClick={() => {
                      navigate(
                        `/form/${form.status.toLowerCase()}/${form._id}`,
                      );
                    }}
                    className="action-btn ban-btn"
                  >
                    View
                  </button>
                  <div style={{ height: "10px" }}></div>
                  {isSuper &&
                    hideId === "" &&
                    (props.formType === "Accept" ||
                      props.formType === "Reject") && (
                      <button
                        onClick={() => {
                          setHideId(form._id);
                        }}
                        className="action-btn remove-btn"
                      >
                        Delete
                      </button>
                    )}
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </>
  );
};

export default FormComponent;
